export default __webpack_public_path__ + "static/media/browser (3).c81c7f3c.svg";